import {
  IsNotEmpty,
  IsArray,
  IsOptional,
  IsString,
  IsUUID,
  IsNumber,
  IsInt,
} from 'class-validator';

import { EventListRequestFilters } from '@app/gen/events';

export class CancelBatchEventsDto {
  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  events: string[];

  @IsNumber(undefined, {
    groups: ['form'],
  })
  @IsNotEmpty({
    groups: ['form'],
  })
  reasonId: number;

  @IsString({
    groups: ['form'],
  })
  @IsOptional({
    groups: ['form'],
  })
  comment?: string;

  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  tags?: string[];

  @IsUUID()
  @IsString()
  @IsOptional()
  companyId?: string;

  @IsInt()
  @IsOptional()
  totalCount?: number;

  filters?: EventListRequestFilters;
}
